module.exports = __webpack_public_path__ + "img/ai_icon1.e48120f4.png";